module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-800.13a07eb.woff";